import { render, staticRenderFns } from "./FlashNewsGeneralPane.vue?vue&type=template&id=4bbc13e6&"
import script from "./FlashNewsGeneralPane.vue?vue&type=script&lang=ts&"
export * from "./FlashNewsGeneralPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports